// utils/generateWebPageSchema.js

export function generateWebPageSchema({ title, description, slug }) {
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": "https://modernbuildremodel.com#webpage",
    "name": title,
    "url": "https://modernbuildremodel.com",
    "description": description,
    "url": `https://modernbuildremodel.com${slug}`,
    "inLanguage": "en-US",
    "publisher": { "@id": "https://modernbuildremodel.com#localbusiness" },
    "mainEntity": { "@id": "https://modernbuildremodel.com#localbusiness" },
  };
}
